import { Button, ButtonTypeMap } from '@mui/joy';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { PropsWithChildren, ReactElement } from 'react';
import { IOverlayLoaderStore } from '../OverlayLoader.store';

type ButtonProps = ButtonTypeMap['props'];

interface IAnnotationNavigationButtonProps extends ButtonProps {
  id?: string;
  loaderKey: string;
  disabled: boolean;
  title: string;
  onClick(): Promise<void> | void;
}

export const AnnotationNavigationButton = observer((props: PropsWithChildren<IAnnotationNavigationButtonProps>): ReactElement => {
  const overlayLoaderStore = useInjection(IOverlayLoaderStore.$);
  const { loaderKey, ...rest } = props;
  const isLoading = !!loaderKey && overlayLoaderStore.isSpinnerVisible(loaderKey);

  return (
    <Button
      {...rest}
      loading={isLoading}
    />
  );
});
